import Vue from 'vue';
import VueI18n from 'vue-i18n';

import zh from './zh';
import en from './en';
import ru from './ru';

Vue.use(VueI18n);

const messages = {
    zh,
    en,
    ru
};

const i18n = new VueI18n({
    locale: 'en', // 设置地区
    messages // 设置地区信息
});

export default i18n;
